import * as React from "react";
import { SVGProps } from "react";
const RespectSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={26}
      height={26}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M0 0h26v26H0V0Z" />
    </mask>
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      mask="url(#a)"
    >
      <path d="M3 14.467.508 13.028l2.631-6.974 2.451.647 4.593-1.367c.63-.187 1.15-.24 1.752.108l1.005.58m6.728 6.449c1.04.628 1.859 1.122 2.072 1.245.597.345.803 1.115.459 1.711a1.256 1.256 0 0 1-1.711.459l-1.09-.63c.597.345.803 1.115.459 1.712a1.256 1.256 0 0 1-1.711.458l-.717-.414c.597.345.803 1.115.458 1.711a1.256 1.256 0 0 1-1.71.459l-1.221-.705c.596.345.802 1.114.458 1.71a1.256 1.256 0 0 1-1.711.46L11.9 19.605m10.446-5.3 3.146-1.179-2.443-6.96-2.668.534-4.592-1.367c-.63-.187-1.15-.24-1.752.108l-3.592 2.073a1.27 1.27 0 0 0-.463 1.729c.348.603 1.104.771 1.729.463.55-.272 1.404-.654 1.979-.855.005 0 .888.535 2.069 1.25" />
      <path d="m8.65 14.987-.187.325a1.256 1.256 0 0 1 1.71-.458c.597.344.803 1.114.459 1.71l-.26.45a1.256 1.256 0 0 1 1.712-.458c.596.344.802 1.114.458 1.71l-.71 1.229a1.256 1.256 0 0 1-1.71.458 1.256 1.256 0 0 1-.459-1.71l-.259.449a1.256 1.256 0 0 1-1.71.458 1.256 1.256 0 0 1-.46-1.71l-.187.325a1.256 1.256 0 0 1-1.711.458h0a1.256 1.256 0 0 1-.459-1.711l.266-.46c-.345.595-1.114.8-1.71.457a1.256 1.256 0 0 1-.458-1.711l.708-1.228a1.256 1.256 0 0 1 1.712-.459c.596.344.802 1.113.459 1.71l.627-1.087a1.256 1.256 0 0 1 1.71-.458h.001c.597.344.803 1.114.458 1.71ZM5.853 14.82l-.71 1.232M8.462 15.312 7.234 17.44M10.372 17.014l-.709 1.228M19.399 15.257l-4.042-2.333M17.43 17.012l-3.549-2.048M14.956 18.477l-2.35-1.357M17.713 11.287h0" />
    </g>
  </svg>
);
export default RespectSvg;
